import { Button, Grow } from "@mui/material";
import useCart from "../utils/useCart";


export default function RewardCard({ item, disabled }){

    const { setCart } = useCart()

    return (
        <Grow in={true}>

            <div className="apply-card">
                
                <img
                    src={item.picture?.url}
                    alt={item.title}
                    className="apply-card-img"
                />

                <span className="apply-card-text">
                    {item.title}
                </span>

                {disabled ?

                    <div></div>

                    :
                
                    <Button 
                        sx={{height: 50}} 
                        onClick={() => setCart({ reward:  item.id})}
                    >
                        Sélectionner
                    </Button>

                }

            </div>

        </Grow>
    );

}